import type { BuroValidatorRequestPFAE } from "@api/sat_apis_new/satApsi";
import { STATUS_CATALOG } from "@helpers/constantes";
import { truncateText } from "@helpers/funciones";
import { CompanyData, LoanApplication } from "@interfaces/store";
import { NipBuroPhone, NipBuroVariant } from "@interfaces/nipBuro";

/** Buró acepta hasta 26 caracteres en nombres. */
const BURO_NAME_MAX = 26;

/** Lo que cambia entre variantes y no es un servicio. Al migrar otra variante se agrega aquí. */
export const NIP_BURO_CONFIG: Record<NipBuroVariant, { screenStatus: string; checkSatBureau: boolean }> = {
  pfae: { screenStatus: STATUS_CATALOG.consulta_buro_pfae.code, checkSatBureau: true },
};

/** Teléfono al que se manda el NIP: PFAE usa el del titular guardado en `company`. */
export const getNipBuroPhone = (company: CompanyData): NipBuroPhone => ({
  countryCode: company.country_code_legal_representative ?? "",
  number: company.phone_legal_representative ?? "",
});

/**
 * Consulta del titular PFAE (legacy `ModalBuroNipPfae`): sin domicilio y con el nombre comercial como
 * `legal_name`. El legacy la manda como `person_Type: "pf"` y sin `application_code`; se copia igual.
 */
export const buildBuroPayloadPfae = (
  company: CompanyData,
  application: LoanApplication,
  personId: string,
): BuroValidatorRequestPFAE => ({
  person_Type: "pf",
  data: {
    rfc: company.rfc,
    transaction_number: String(application.id),
    legal_name: truncateText(company.name || "", BURO_NAME_MAX),
    first_name: truncateText(company.pfae_name || "", BURO_NAME_MAX),
    second_name: "",
    father_last_name: truncateText(company.pfae_last_name || "", BURO_NAME_MAX),
    mother_last_name: truncateText(company.pfae_last_name_2 || "", BURO_NAME_MAX),
    reenter_NIP: true,
    authorization_label_response: true,
    loan_application_id: String(application.id),
    is_endorsement: false,
    person_id: personId,
  },
});
